import React, { useEffect, useState } from 'react';

import Effect from '../../../../dmView/components/EncounterColumn/Effect.js';
import { effectImgMap } from '../../../../dmView/constants.js';

const PlayerUiEffectContainer = ({ creature, socket }) => {
    const [effects, setEffects] = useState(creature.effects || []);

    useEffect(() => {
        setEffects(creature.effects || []);
    }, [creature.creatureGuid, creature.effects]);

    const updateCreatureEffects = (event, effect) => {
        event.stopPropagation();

        setEffects((currentEffects) => {
            const alreadyExists = currentEffects.includes(effect);
            const nextEffects = alreadyExists
                ? currentEffects.filter((existingEffect) => existingEffect !== effect)
                : [...currentEffects, effect];

            socket.emit('playerEffectChange', effect, alreadyExists ? 'remove' : 'add', creature.creatureGuid, 'player');
            return nextEffects;
        });
    };

    return (
        <div className='effectsBarContainerPlayerUi editHpGrowPlayerUi'>
            <div className="effectsBarPlayerUi" onClick={(event) => event.stopPropagation()}>
                {Object.entries(effectImgMap).map(([effect, image]) => (
                    <Effect
                        key={`${creature.creatureGuid}-${effect}`}
                        currentEffects={effects}
                        updateCreatureEffects={updateCreatureEffects}
                        effect={effect}
                        image={image}
                    />
                ))}
            </div>
        </div>
    );
};

export default PlayerUiEffectContainer;